import { graphql } from "@cappelendamm/crystallize-types/search/gql";
import { CRYSTALLIZE_IDS } from "../../crystallize-constants.js";
const request = async (client, cursor) => {
    const response = await client.search.request(graphql(`
      query GetBookClubPlans($shapeIdentifiers: [String!], $after: String) {
        search(
          filter: { include: { shapeIdentifiers: $shapeIdentifiers } }
          after: $after
        ) {
          edges {
            node {
              ... on Product {
                id
                name
                matchingVariant {
                  name
                  sku
                }
              }
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    `), {
        shapeIdentifiers: [CRYSTALLIZE_IDS.SHAPE.PRODUCT.BOOK_CLUB.ID],
        after: cursor,
    });
    const edges = response.search.edges;
    const nodes = edges
        ?.filter((edge) => Boolean(edge.node.matchingVariant?.sku))
        .map((edge) => ({
        ...edge.node.matchingVariant,
        product: {
            id: edge.node.id,
            name: edge.node.name,
        },
    }));
    return {
        hasNextPage: response.search.pageInfo.hasNextPage,
        endCursor: response.search.pageInfo.endCursor,
        nodes,
    };
};
export const getBookClubPlans = async ({ client }) => {
    const plans = [];
    let cursor = null;
    let nextPage = true;
    while (nextPage) {
        const { hasNextPage, endCursor, nodes } = await request(client, cursor ?? "");
        nextPage = hasNextPage;
        cursor = endCursor;
        if (nodes) {
            plans.push(...nodes);
        }
    }
    return plans;
};
